import { bootstrap } from "@usable/office-shell";
import { excelToolSchemas, handleExcelToolCall } from "./lib/excel-tools";
import { excelContextProvider } from "./lib/excel-context";

// The whole Excel add-in: host-specific tools + config; the shared shell does the rest.
// Logo + ribbon icons come from the shared @usable/office-assets brand set.
bootstrap({
  appName: "Excel Assistant",
  documentNoun: "workbook",
  embedToken:
    process.env.EMBED_TOKEN ??
    "uc_9aa8469f94a1a1065e4210218013e171775c319652d283f8b120df23e7fc3e22",
  dbName: "usable-excel-chat-history",
  toolSchemas: excelToolSchemas,
  // Thread the embed's requestId so the shared execution layer dedups
  // double-mount re-deliveries exactly (not by content — which collapses
  // legitimate parallel same-args calls).
  onToolCall: (tool, args, caps) => handleExcelToolCall(tool, args, caps.requestId),
  contextProvider: excelContextProvider,
});
